import clone from 'immutability-helper'

export class Color {
  /**
   * @param red The red color value. A number between 0 and 255.
   * @param green The green color value. A number between 0 and 255.
   * @param blue The blue color value. A number between 0 and 255.
   * @param alpha The alpha value. A number between 0 and 255.
   */
  constructor(readonly red: number, readonly green: integer, readonly blue: integer, readonly alpha: number = 1) {}

  getColor(): number {
    return Phaser.Display.Color.GetColor(this.red, this.green, this.blue)
  }

  setAlpha(a: number): Color {
    return clone(this as Color, {alpha: {$set: a}})
  }
}

export const LIGHT_WHITE = new Color(0x22, 0x22, 0x22)

export const BLACK = new Color(0x00, 0x00, 0x00)
export const RED = new Color(0xFF, 0x00, 0x00)
export const GREEN = new Color(0x00, 0xFF, 0x00)
export const DARK_GREEN = new Color(0x00, 0x99, 0x00)
export const DARK_DARK_GREEN = new Color(0x00, 0x40, 0x00)
export const BLUE = new Color(0x00, 0x00, 0xFF)
export const LIGHT_BLUE = new Color(0x00, 0x00, 0x77, 0.5)
export const YELLOW = new Color(0xFF, 0xFF, 0x00)
export const WHITE = new Color(0xFF, 0xFF, 0xFF)
export const GRAY = new Color(0x99, 0x99, 0x99)
export const DARK_GRAY = new Color(0x55, 0x55, 0x55)
export const DARK_BLUE = new Color(0x00, 0x00, 0xFF)

